import { ChartIcon } from '@sharedCR/coreDesignSystem/icons';

import { NAVIGATION_ITEM_TYPE } from 'constants/navigation';

import { MARGIN_CENTER_ANY_CLAIM, MarginCenterPaths } from './routesConfig/marginCenter';

// Margin Center is a SINGLE top-level entry that opens its own workspace ("center") — the 11 pages
// are a persistent LEFT sub-navigation rendered inside MarginCenterLayout (see marginCenterSections.js),
// NOT 11 flat items sprayed into the global/top navigation. The root path redirects to Desk Cockpit;
// the ITEM stays highlighted across every /margin-center/* sub-route (matchPath end:false).
//
// Gated on ANY margin/programs/channels claim (MARGIN_CENTER_ANY_CLAIM), NOT adjustmentCriteria — the
// latter is the legacy LLPA surface and is company-restricted, which silently hid the whole center (DEV-6325).
export const marginCenterNavItem = {
  id: 'margin-center',
  title: 'Margin Center',
  type: NAVIGATION_ITEM_TYPE.ITEM,
  icon: ChartIcon,
  url: MarginCenterPaths.root.path,
  exact: false,
  pageCode: MARGIN_CENTER_ANY_CLAIM,
};
